import { Box, Flex } from '@chakra-ui/react';
import { ExportPdfButton } from '~/screens/MediaPackDetailDefaultScreen/components/ExportPdfButton';
import { ShareButton } from '~/screens/MediaPackDetailDefaultScreen/components/ShareButton';
import { IMediaPackPDFData } from '~/types';
import { useBreakpointValue } from '~/utils-ts';

interface Props {
  exportPdfData: IMediaPackPDFData;
  previewAndShareLink: string;
}

export const ButtonsSection: React.FC<Props> = ({
  exportPdfData: {
    creator,
    creatorBenchmarks,
    creatorInsights,
    mediaPack,
    pdfImages,
  },
  previewAndShareLink,
}) => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box width="100%" backgroundColor="neutral.50">
      <Box maxWidth="1500px" margin="auto" paddingBottom={10}>
        <Box backgroundColor="neutral.50">
          <Flex
            justifyContent="flex-end"
            paddingX={{
              base: 8,
              md: 20,
              xl: 48,
            }}
          >
            <ExportPdfButton
              data={{
                creator,
                creatorBenchmarks,
                creatorInsights,
                mediaPack,
                pdfImages,
              }}
              marginRight={2}
              iconProps={{
                boxSize: 4,
              }}
            />

            <ShareButton
              href={previewAndShareLink}
              buttonText={isMobile ? 'Share' : 'Preview & Share'}
              shouldBeResponsive={false}
            />
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};
